var map = {
	"./frontend/AndroidGuide.vue": 7881,
	"./frontend/BetslipHistory.vue": 6634,
	"./frontend/BodyFB.vue": 648,
	"./frontend/ContactUs.vue": 9331,
	"./frontend/DataTable.vue": 6107,
	"./frontend/Deposit.vue": 6582,
	"./frontend/FinishedMatches.vue": 299,
	"./frontend/History.vue": 2858,
	"./frontend/Home.vue": 479,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe.vue": 2251,
	"./frontend/Index.vue": 9595,
	"./frontend/Live.vue": 6110,
	"./frontend/LiveScore.vue": 2184,
	"./frontend/MainMenu.vue": 7294,
	"./frontend/MaungFB.vue": 3101,
	"./frontend/Promotion.vue": 6856,
	"./frontend/Setting.vue": 4311,
	"./frontend/TwodThreed.vue": 8095,
	"./frontend/VideoLink.vue": 5006,
	"./frontend/Welcome.vue": 406,
	"./frontend/Withdraw.vue": 6259,
	"./frontend/auth/Login.vue": 2918,
	"./frontend/auth/Register.vue": 588,
	"./frontend/auth/Rule.vue": 7124,
	"./frontend/components/AccountSelect.vue": 2128,
	"./frontend/components/DataTable.vue": 4488,
	"./frontend/components/FBPreviewVoucher.vue": 8948,
	"./frontend/components/FBVoucher.vue": 6818,
	"./frontend/components/FootballTeamCard.vue": 8675,
	"./frontend/components/GroupBox.vue": 515,
	"./frontend/components/InputSelectDrawModal.vue": 1307,
	"./frontend/components/LuckyWheel.vue": 187,
	"./frontend/components/NormalBox.vue": 9250,
	"./frontend/components/PreviewVoucher.vue": 9053,
	"./frontend/components/SideNav.vue": 5586,
	"./frontend/components/Table.vue": 7050,
	"./frontend/components/ThreedGroupBox.vue": 4806,
	"./frontend/components/TwoDSelect.vue": 3841,
	"./frontend/components/Voucher.vue": 4569,
	"./frontend/normal-user/2d/2d.vue": 4818,
	"./frontend/normal-user/2d/ClosedDays.vue": 769,
	"./frontend/normal-user/2d/Home.vue": 9733,
	"./frontend/normal-user/2d/Winner.vue": 6563,
	"./frontend/normal-user/3d/3d.vue": 850,
	"./frontend/normal-user/3d/Home.vue": 3208,
	"./frontend/normal-user/DreamBooks.vue": 3912,
	"./frontend/normal-user/Index.vue": 6012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Fishing.vue": 1879,
	"./frontend/normal-user/game/Game.vue": 1217,
	"./frontend/normal-user/game/Slot.vue": 1113,
	"./frontend/normal-user/shankomee/Room.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;